export const filterTitleDesktopWidth = 80
export const filterTitleMobileWidth = 58

export const CUSTOM_VALUE = 'custom'
